function menu() {
    const menu = document.getElementsByClassName('nav__mobile-menu')
    const menuDD = document.getElementsByClassName('nav__links')
// console.log(menu)
// console.log(menuDD)

    if (menu[0]) {
        // console.log(menu)
        // console.log(menuDD)
        menu[0].addEventListener('click', function () {
            if (menuDD[0].classList.contains('hidden')) {
                menuDD[0].classList.remove('hidden')
                menu[0].classList.add('open')
            } else {
                menuDD[0].classList.add('hidden')
                menu[0].classList.remove('open')
            }
        })
    }

    if(window.innerWidth > 768) {
        menuDD[0].classList.remove('hidden')
        menu[0].classList.add('open')
    } else {
        menuDD[0].classList.add('hidden')
        menu[0].classList.remove('open')
    }
}
menu()
window.addEventListener('resize', menu)